// possible states of the booking state machine
export const STEP_AVAILABILITY = 'availability' // Old flow
export const STEP_CAPACITY = 'capacity'
export const STEP_PAYMENT = 'payment'
export const STEP_CHANGE_DATES = 'change-dates'
export const STEP_CHANGE_PACKAGE = 'change-package'
export const STEP_CHANGE_DATES_LEGACY = 'change-dates-legacy' // Old flow
export const STEP_BOOK_DATES = 'book-dates'
export const STEP_CONFIRMATION = 'confirmation'
export const STEP_DEPARTING_FLIGHT = 'departing'
export const STEP_RETURNING_FLIGHT = 'returning'
export const STEP_MONTH_CALENDAR = 'month'
export const STEP_EXPERIENCES = 'experiences'
export const STEP_DAY_CALENDAR = 'dates'
export const STEP_TOUR_DATES = 'tour-dates'
export const STEP_BALANCE_PAYMENT = 'deposit-balance-payment'
export const STEP_INSTALMENT_PAYMENT = 'instalment-payment'
export const STEP_INSTALMENT_BALANCE_PAYMENT = 'instalment-balance-payment'
export const STEP_RESERVE_FOR_ZERO_PAYMENT = 'reserve-for-zero-payment'

// Ordered steps for standard accommodation (Flash/TAO/LME) offers
export const STD_BOOKING_STEPS = [STEP_EXPERIENCES, STEP_PAYMENT]

export const BOOKING_BALANCE_STEPS = [STEP_BALANCE_PAYMENT, STEP_INSTALMENT_PAYMENT, STEP_INSTALMENT_BALANCE_PAYMENT, STEP_RESERVE_FOR_ZERO_PAYMENT]
